import React, { useState, useEffect } from 'react'
import Axios from '../../../../../Axios'
import { Urls } from '../../../../../Urls'
//import Autosuggestor from './AutoComplete/AutoCompleteTransporter'
import Autosuggest from "../../../../TrucksAvailable/AutoComplete/AutocompletetransporterV2"
import AutoComplete from '../../../../Shared/AutosuggestV2/Autosuggestv2'

/**
* Sends a PUT request to the freight_master endpoint to save user input.
* @param {Object} payload - payload to be sent in the PUT request.
* @returns {Promise<AxiosResponse>} response from the API call.
*/
export const save_details_api = (payload) => {
  return Axios.put(`${Urls.freight_master}?action=save_user_input`, payload)
}

/**
* Sends a PUT request to the freight_master endpoint to update excel log.
* @param {Object} payload - The payload to be sent in the PUT request.
* @returns {Promise<AxiosResponse>} - The response from the API call.
*/
export const next_page = (payload) => {
  return Axios.put(`${Urls.freight_master}?action=update_excel_log`, payload)
}

/**
* Retrieves the current milliseconds since the Unix epoch.
* @returns {number} - current milliseconds since the Unix epoch.
*/
export const getmillisec = () => {
  const d = new Date();
  return d.getMilliseconds();
}

/**
* Component that renders an auto-suggest input field for a location.
* @param {Object} value - initial value for the auto-suggest input.
* @param {function} onSelect - function to be called when a suggestion is selected.
* @param {string} placeholder - placeholder text for the auto-suggest input.
* @param {boolean} showlocation - Whether to show the location name in the input field.
* @returns {JSX.Element}
*/
// export const Suggestion = ({value = {}, onSelect = '',placeholder='Origin', showlocation=false}) =>{
//     const [searchtext, setSearchtext] = useState('')
//     const [origin, setOrigin] = useState({})
//     // useEffect to set default text for input
//     useEffect(() => {
//         setSearchtext(value && value.location_name ? value.location_name : value.location && value.location.suggestion? value.location.suggestion: '')
//         setOrigin(value? value: null)
//     }, [])

//     return <div style={{position:'absolute', top:'0', width:'100%'}}>
//             <AutoSuggest
//                 key={"Origin_Key"}
//                 value={showlocation? searchtext.split(',')[0]: searchtext}
//                 placeholder={placeholder}
//                 onSelect={e => {
//                     setOrigin(e)
//                     if(onSelect){
//                         onSelect(e)
//                     }
//                 }}
//                 onChange={e => {
//                     setSearchtext(e)
//                     setOrigin({})
//                     if(onSelect && showlocation){
//                         onSelect()
//                     }
//                 }}
//             />
//             {!origin.location? <span style={{color:'red'}}>Please select location from dropdown</span> :null }
//         </div>
// }

export const Suggestion = ({
  value = {},
  onSelect = '',
  placeholder = 'Origin',
  showlocation = false,
}) => {
  const [selectedOption, setSelectedOption] = useState(null)
  const [origin, setOrigin] = useState({})

  useEffect(() => {
    const locationName =
      value && value.location_name
        ? value.location_name
        : value && value.location && value.location.suggestion
          ? value.location.suggestion
          : ''

    if (locationName) {
      setSelectedOption({
        label: showlocation ? locationName.split(',')[0] : locationName,
        value: locationName,
        full: value,
      })
      setOrigin(value)
    } else {
      setSelectedOption(null)
      setOrigin({})
    }
  }, [])

  return (
    <div style={{ position: 'absolute', top: '0', width: '100%' }}>
      <AutoComplete
        value={selectedOption}
        placeholder={placeholder}
        onSelect={(fullItem) => {
          if (fullItem) {
            setOrigin(fullItem)
            if (onSelect) onSelect(fullItem)
          } else {
            setOrigin({})
            if (onSelect && showlocation) onSelect()
          }
        }}
        onChange={(val) => {
          if (!val) {
            setSelectedOption(null)
            setOrigin({})
            if (onSelect && showlocation) onSelect()
          } else {
            setSelectedOption({ label: val, value: val, full: {} })
          }
        }}
      />
      {!origin.location ? (
        <span style={{ color: 'red' }}>Please select location from dropdown</span>
      ) : null}
    </div>
  )
}


/**
* Component that renders an auto-suggest input field for a transporter.
* @param {Object} transporter - The initial value for the auto-suggest input.
* @param {function} setcurrenttransporter - function to be called when a suggestion is selected.
* @returns {JSX.Element}
*/
export const TransporterSuggest = ({ transporter = {}, setcurrenttransporter = '' }) => {
  const [searchText, setSearchText] = useState('')
  useEffect(() => {
    setSearchText(transporter.transporter && transporter.transporter.transporter_id ? transporter.transporter.transporter_name : '')
  }, [])



  return <div>
    {/* <Autosuggestor
    placeholder="Add Transporters"
    value={searchText}
    onChange={(e) => {
      if (setcurrenttransporter) {
        setcurrenttransporter({})
      }
      setSearchText(e)
    }}
    onSelect={e => setSearchText(e)}
    getResults={e => {
      if (setcurrenttransporter) {
        setcurrenttransporter(e)
      }
    }}
  /> */}
    <Autosuggest
      placeholder="Add Transporters"
      value={searchText}
      onChange={(val) => {
        if (setcurrenttransporter) {
          setcurrenttransporter({});
        }
        setSearchText(val);
      }}
      onSelect={(transporter) => {
        setSearchText(transporter?.transporter_name || "");
      }}
      getResults={(transporter) => {
        if (setcurrenttransporter) {
          setcurrenttransporter(transporter);
        }
      }}
      type="transporter"
    />
    {!transporter.transporter || !transporter.transporter.transporter_name ? <label style={{ color: 'red', fontSize: '10px' }}>Please Select Transporter from dropdown</label> : null}
  </div>
}